export default "__VITE_ASSET__Dl_1nNze__"